import { useFetch } from '@vueuse/core'

const fetchGeoLocation = async (address: string) => {
  const { isFinished, error, data } = await useFetch(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${
      import.meta.env.PUBLIC_APP_GEOCODE_API_KEY
    }`,
  ).json()

  if (error.value) throw new Error(error.value)

  if (isFinished) return data.value.results[0].geometry.location
}

export default fetchGeoLocation
